export default "__VITE_ASSET__RB7yTwt1__"